export const EmployeesErrors: Record<string, string> = {
  'Supplier cannot be deleted due to relation.':
    'Não foi possível excluir o funcionário. Existem vinculos com outros módulos.',
  'Employee cannot be deleted due to relation.':
    'Não foi possível excluir o funcionário. Existem vinculos com outros módulos.',
};
